module.exports = __webpack_public_path__ + "static/media/10.Play Time 4.d743bae7.gif";